import React, { useContext, useEffect, useState } from "react";
import HighCharts from "./Chart_table";
import Common from "./Common";
import {
  TableBody,
  TableCell,
  TableRow,
  Modal,
  Table,
  Box,
  ButtonBase,
  Typography,
} from "@mui/material";
import DataContext from "../../ContextServer/DataContext";

export const enShowValue = {
  ShowPM025: 0,
  ShowPM100: 1,
  ShowOzone: 2,
  ShowH2S: 3,
  ShowDilution: 4,
  ShowNH3: 5,
  tvoc: 6,
};

function ButtonAvr(props) {
  const [unit, setUnit] = useState("㎍/㎥");

  const AirViewValue = () => {
    if (props.showValue === enShowValue.ShowPM025) {
      return (
        <div>
          <Common name={"초미세먼지"} />
          <div className="high">
            <HighCharts name={"초미세먼지"} selectedDivision={"대기"} />
          </div>
        </div>
      );
    } else if (props.showValue === enShowValue.ShowPM100)
      return (
        <div>
          <Common name={"미세먼지"} />
          <div className="high">
            <HighCharts name={"미세먼지"} selectedDivision={"대기"} />
          </div>
        </div>
      );
    else if (props.showValue === enShowValue.ShowOzone)
      return (
        <div>
          <Common name={"오존"} />
          <div className="high">
            <HighCharts name={"오존"} selectedDivision={"대기"} />
          </div>
        </div>
      );
    else if (props.showValue === enShowValue.tvoc)
      return (
        <div>
          <Common name={"총휘발성유기화합물"} />
          <div className="high">
            <HighCharts name={"총휘발성유기화합물"} selectedDivision={"대기"} />
          </div>
        </div>
      );
  };

  const nameChanged = (__name__) => {
    if (__name__ === enShowValue.ShowPM025 || enShowValue.ShowPM100) {
      setUnit("㎍/㎥");
    } else if (__name__ === enShowValue.ShowOzone) {
      setUnit("ppm");
    } else if (__name__ === enShowValue.tvoc) {
      setUnit("tvoc");
    }
  };
  return (
    <div className="mainBtn">
      {<AirViewValue className="viewValue" />}
      <div className="Airbtn">
        <ButtonBase
          className={
            props.showValue === enShowValue.ShowPM025 ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowPM025);
            nameChanged(enShowValue.ShowPM025);
          }}
        >
          초미세먼지 PM-2.5
        </ButtonBase>

        <ButtonBase
          className={
            props.showValue === enShowValue.ShowPM100 ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowPM100);
            nameChanged(enShowValue.ShowPM100);
          }}
        >
          미세먼지 PM-10
        </ButtonBase>

        <ButtonBase
          className={
            props.showValue === enShowValue.ShowOzone ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowOzone);
            nameChanged(enShowValue.ShowOzone);
          }}
        >
          오존 O3
        </ButtonBase>
      </div>
    </div>
  );
}

export function BadSmell(props) {
  const { setSelectedSensor } = useContext(DataContext);
  const StinkViewValue = () => {
    let sensorName = "";

    switch (props.showValue) {
      case enShowValue.ShowH2S:
        sensorName = "황화수소";
        break;
      case enShowValue.ShowDilution:
        sensorName = "복합악취";
        break;
      case enShowValue.ShowNH3:
        sensorName = "암모니아";
        break;
      case enShowValue.tvoc:
        sensorName = "총휘발성유기화합물";
        break;
      default:
        break;
    }

    return (
      <div>
        <div className="high">
          <HighCharts name={sensorName} selectedDivision={"악취"} />
        </div>
      </div>
    );
  };

  return (
    <div className="stinkbtn">
      {<StinkViewValue className="viewValue" />}

      <div className="stinkValue">
        <ButtonBase
          className={
            props.showValue === enShowValue.ShowDilution ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowDilution);
            setSelectedSensor('복합악취')
          }}
        >
          복합악취
        </ButtonBase>

        <ButtonBase
          className={
            props.showValue === enShowValue.ShowH2S ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowH2S);
                 setSelectedSensor('황화수소')
          }}
        >
          황화수소 H2S
        </ButtonBase>

        <ButtonBase
          className={
            props.showValue === enShowValue.ShowNH3 ? "click" : "basic"
          }
          onClick={() => {
            props.setShowValue(enShowValue.ShowNH3);
                 setSelectedSensor('암모니아')
          }}
        >
          암모니아 NH3
        </ButtonBase>

        <ButtonBase
          className={props.showValue === enShowValue.tvoc ? "click" : "basic"}
          onClick={() => {
            props.setShowValue(enShowValue.tvoc);
                 setSelectedSensor('총휘발성유기화합물')
          }}
        >
          TVOC
        </ButtonBase>
      </div>
    </div>
  );
}

export function Minwon(props) {
  const { odorReports } = useContext(DataContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };
    // 초기 로드 시 및 윈도우 크기 변경 시 호출
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // console.log("props.seqNo : " + props.seqNo);
  // odorReports.forEach((report, index) => {
  //   console.log(`Report ${index + 1}:` + report);
  //   console.log("odorReports.seqno : " + report.seqno);
  // });
  // console.log("민원리스트 : " + minwonDataList);
  let minwonDataList = [];

  if (odorReports && odorReports.length > 0) {
    minwonDataList = odorReports.filter((hole) => hole.seqno === props.seqNo);
    // console.log("민원리스트 : " + minwonDataList);
  }

  var thisSite = "잠시만 기다려 주세요.";

  thisSite = minwonDataList?.air_pollution_comp_nm;

  const style = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #fa8526",
    boxShadow: 24,
    p: "10px",
    zIndex: 9999,
    borderRadius: "5px",
  };

  // 모바일 화면 스타일
  const mobileStyle = {
    ...style, // 기존 스타일을 모두 상속
    width: "90%", // 모바일 화면에서는 가로폭을 100%로 설정
    top: "53%",
    p: "5px",
  };

  return (
    <div className="minwonContainer">
      <Modal
        open={props.modalOpen}
        onClose={() => props.ass()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={isMobile ? mobileStyle : style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ textAlign: "center" }}
          >
            민원 내용
          </Typography>
          <Typography id="modal-modal-description">
            <Table className="modalTable">
              <TableBody>
                <TableRow>
                  <TableCell style={{ padding: "12px" }}>
                    신고 주소 : {minwonDataList[0]?.report_addr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: "12px" }}>
                    악취 강도 : {minwonDataList[0]?.stink_levelnm}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: "12px" }}>
                    악취 종류 : {minwonDataList[0]?.stink_div}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: "12px" }}>
                    신고 시각 : {minwonDataList[0]?.datetime}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: "12px" }}>
                    세부내역 : {minwonDataList[0]?.bigo}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

export default ButtonAvr;
